import React from 'react';
import {
    Box,
    FormControlLabel,
    Checkbox,
    Typography,
    Autocomplete,
    TextField
} from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LoadingComponent from '@Components/LoadingComponent/LoadingComponent';

import {
    DEPARTMENTS,
    UI_CONSTANTS,
    COMPONENT_IDS
} from './SupportRequestTab.constants';
import { createChangeHandler, createAutocompleteHandler } from './SupportRequestTab.utils';

// Icon mapping
const DEPARTMENT_ICONS = {
    [DEPARTMENTS.MARKETING]: CampaignIcon,
    [DEPARTMENTS.SUPPLY_CHAIN]: LocalShippingIcon
};

export const DepartmentSelector = ({
                                       department,
                                       label,
                                       placeholder,
                                       isChecked,
                                       isLoading,
                                       users,
                                       selectedMember,
                                       onCheckChange,
                                       onMemberChange,
                                       disabled,
                                       checkboxId
                                   }) => {
    const DepartmentIcon = DEPARTMENT_ICONS[department];

    return (
        <>
            <Box sx={styles.checkboxContainer}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isChecked}
                            onChange={createChangeHandler(onCheckChange, disabled)}
                            color="primary"
                            size="small"
                            icon={<DepartmentIcon fontSize="small" color="disabled" />}
                            checkedIcon={<DepartmentIcon fontSize="small" color="primary" />}
                            disabled={disabled}
                            sx={styles.checkbox}
                            id={checkboxId}
                        />
                    }
                    label={
                        <Typography
                            variant="body2"
                            sx={styles.checkboxLabel(disabled)}
                            htmlFor={checkboxId}
                            component="span"
                        >
                            {label}
                        </Typography>
                    }
                    sx={styles.formControl}
                />
            </Box>

            {isChecked && (
                <Box sx={styles.autocompleteContainer}>
                    {isLoading ? (
                        <LoadingComponent
                            size={UI_CONSTANTS.LOADING_SIZE}
                            thickness={UI_CONSTANTS.LOADING_THICKNESS}
                            color="primary"
                        />
                    ) : (
                        <Autocomplete
                            options={users}
                            getOptionLabel={(option) => option.username}
                            value={selectedMember}
                            onChange={createAutocompleteHandler(onMemberChange, disabled)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder={placeholder}
                                    size="small"
                                    disabled={disabled}
                                />
                            )}
                            size="small"
                            disabled={disabled}
                        />
                    )}
                </Box>
            )}
        </>
    );
};

const styles = {
    checkboxContainer: {
        display: 'flex',
        alignItems: 'center',
        ml: 0
    },
    checkbox: {
        p: UI_CONSTANTS.CHECKBOX_PADDING,
        mr: 1
    },
    checkboxLabel: (disabled) => ({
        fontSize: UI_CONSTANTS.FONT_SIZES.LABEL,
        color: 'text.primary',
        cursor: disabled ? 'default' : 'pointer',
        userSelect: 'none'
    }),
    formControl: {
        m: 0
    },
    autocompleteContainer: {
        pl: UI_CONSTANTS.INDENT_SPACING,
        mb: 1
    }
};